import {Repository} from '@/repositories/Base/Repository'

class ComplementRepository extends Repository {
    endpoint = 'mapping/specimens/complements/table'

}

export default new ComplementRepository()
